import React from 'react';
import { render } from 'react-dom';
import 'whatwg-fetch';
import App from './views/App';
import TropicErrorBoundaryModal from '@/js/components/TropicErrorBoundaryModal';
import '../bugsnag-config';

import Keen from 'keen-tracking';
import frontEndConfig from 'config';

const helpers = Keen.helpers;
const utils = Keen.utils;

const client = new Keen({
	projectId : frontEndConfig.keen.projectId,
	writeKey : frontEndConfig.keen.writeKey
});

Keen.ready(function() {
	client.initAutoTracking();
});

const sessionCookie = utils.cookie('keen-cookie');
if (!sessionCookie.get('guest_id')) {
  sessionCookie.set('guest_id', helpers.getUniqueId());
}

export default {

	keen: client,
	// requests is an object or array of objects
	fetch: (requests) => {

		if(requests.mock) {
			let mockPromise = Promise.resolve('mock');
			return mockPromise;
		}

		let requestsArray = requests;
		if(typeof requests === 'object') {
			requestsArray = [requests];
		}

		let promiseArray = requestsArray.map(r => {
			let headers = new Headers();
			if (r.method === 'POST' || r.method === 'PUT' || r.method === 'PATCH') {
				headers.append('Content-Type', r.contentType || 'application/json');
			}

			let context = {
				tech: {
					browser: helpers.getBrowserProfile(),
					title: document.title,
					url: document.location.href
				}
			};

			// non-ascii characters cannot be in headers, try to sanitize, report to keen if any unusual characters
			let stringifiedContext = { tropic_context : JSON.stringify(context) };
			let sanitizedContext = stringifiedContext.tropic_context.replace(/[^\x20-\xAF]+/g, "");
			if (stringifiedContext.tropic_context != sanitizedContext) {
				let forbiddenCharacters = stringifiedContext.tropic_context.replace(/[\x20-\xAF]+/g, ",").split(",");
				client.recordEvent('BadCharacterFound', {
					character: forbiddenCharacters.map(function(str) {
						return str + ": " + str.codePointAt(0);
					})
				});
			}

			headers.append('tropic_context', sanitizedContext);

			let requestObj = {
				method: r.method || 'GET',
				headers: headers,
				credentials: 'include'
			};

			if(r.body) {
				requestObj.body = r.body;
			}

			let request = new Request(r.url, requestObj);

			return fetch(request).then(
				resp => {
					// 204 body should not be attempted to be parsed as it is empty
					if (resp.status === 204) return;

					if (r.blobHandler) {
						let filename = null;
						if (resp.headers.has('content-disposition')) {
							const contentDisposition = resp.headers.get('content-disposition');
							// simple parser for content-disposition header, doesn't support all features but we are in full control of the value in these cases
							filename = contentDisposition
								.split(/;\s?/)
								.filter(part => part.startsWith('filename='))
								.map(part => part.split('=')[1])
								.reduce((acc, filename) => acc = filename, null);
						}

						return resp.blob().then(blob => {
							r.blobHandler(blob, filename);
						});
					}

					return resp.json().then(responseBody => {
						// status 200-299 and no error object, action successful
						if (resp.ok && !responseBody.error) return responseBody;

						/* status 400-599, or 2-- with an error which means good request,
							but the action was unsuccessful due to back-end validation or
							business rule violation
						*/
						else return Promise.reject(responseBody.error);
					});
				}).catch(error => {
					// network error is encountered
					return Promise.reject(error);
				});
		});

		let result;
		if (promiseArray.length > 1) {
			result = Promise.all(promiseArray);
		} else {
			result = promiseArray[0];
		}

		return result;
	},

	bootstrapView: function (View) {
		const MOUNT_NODE = document.getElementById('viewport');
		// app will clone view and merge in some props
		render(
			<TropicErrorBoundaryModal>
				<App><View/></App>
			</TropicErrorBoundaryModal>, MOUNT_NODE);
	}
};
